import { lazy } from "react";

const SystemSettingPage = lazy(() => import("@pages/systemSetting"));
const ResetPwdPage = lazy(
  () => import("@pages/systemSetting/resetPassword/page"),
);

const systemSettingRoute: RouteConfig[] = [
  {
    path: "/systemSetting", // 英文路径
    name: "systemSetting", // 英文 name 留给自己
    crumbTitle: "系统设置", // 中文标题给面包屑
    component: SystemSettingPage, // 默认显示档案页
    children: [
      {
        path: "/systemSetting/resetPwd",
        name: "resetPwd",
        crumbTitle: "修改密码", // 中文标题给面包屑
        component: ResetPwdPage,
      },
    ],
  },
];

export default systemSettingRoute;
